import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'
import { JurisdictionOverridesView } from '@/components/jurisdictions/JurisdictionOverridesView'
import {
    useAddJurisdictionOverride,
    useJurisdictionOverrides,
    useLiftJurisdictionOverride,
} from '@/hooks/api/useJurisdictionOverrides'
import { countryName } from '@/lib/countries'

export const Route = createFileRoute('/jurisdictions')({
    component: JurisdictionsPage,
})

// Every console role can read the provisional blocks; JurisdictionOverridesView gates adding and
// lifting behind RoleGate (BLO-848).
export function JurisdictionsPage() {
    const query = useJurisdictionOverrides()
    const add = useAddJurisdictionOverride()
    const lift = useLiftJurisdictionOverride()

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold">Jurisdictions</h1>
                <p className="text-muted-foreground text-sm">
                    Provisional country blocks for market-exit tripwires 1 to 3. They sit on top of
                    the jurisdiction matrix and take effect without a code release.
                </p>
            </div>
            <JurisdictionOverridesView
                data={query.data}
                isLoading={query.isLoading}
                error={query.error}
                onAdd={async (body) => {
                    const row = await add.mutateAsync(body)
                    toast.success(`${countryName(row.country_code)} is blocked`)
                }}
                onLift={async (id, body) => {
                    const row = await lift.mutateAsync({ id, body })
                    toast.success(`Block on ${countryName(row.country_code)} lifted`)
                }}
            />
        </div>
    )
}
